import React from 'react'
import { useWatch } from 'react-hook-form'
import { widgets as widgetList } from '../widgets'
import { CardViewMode } from '@edge/spark/io-dashboards'
import { convertDashboardCardFormatFieldsToGenericWidgetConfig } from './converters'
import type { DashboardCardConfig } from './types'
import type { DashboardCardDef } from '@edge/spark/io-dashboards'

interface Props {
    widgetDef: DashboardCardDef
}

export const CardWidget: React.VFC<Props> = ({ widgetDef }: Props) => {
    const aql = useWatch<DashboardCardConfig, 'aql'>({ name: 'aql' })
    const format = useWatch<DashboardCardConfig, 'format'>({ name: 'format' })
    const workflows = useWatch<DashboardCardConfig, 'workflows'>({ name: 'workflows' })
    const searchCardType = widgetDef.config?.contactLogSearch ? 'CONTACT_LOG' : 'SEARCH'
    const config = convertDashboardCardFormatFieldsToGenericWidgetConfig(format, aql, searchCardType, workflows)

    if (!config) {
        return null
    }

    const Widget = widgetList.find(({ name }) => name === widgetDef.type)?.component

    if (!Widget) {
        return null
    }

    return <Widget config={config} widgetId={widgetDef.id} cardViewMode={CardViewMode.CONFIGURATION} readonly />
}

export default CardWidget
